import moment from "moment";

const initialState = {
  status: "invalid",
  filters: {
    open: true,
    query: {
      "q[time_from_gteq]": moment().format("YYYY-MM-01"),
      "q[time_from_lt]": moment()
        .add(1, "months")
        .format("YYYY-MM-DD"),
    },
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case "TIME_RECORDS_TOGGLE_FILTERS":
      return {
        ...state,
        filters: { ...state.filters, open: !state.filters.open },
      };
    case "TIME_RECORDS_SET_FILTERS_QUERY":
      return {
        ...state,
        filters: { ...state.filters, query: action.query },
      };
    case "TIME_RECORDS_SEARCHING":
      return {
        ...state,
        status: "searching",
      };
    case "TIME_RECORDS_LOADING":
      return {
        ...state,
        status: "loading",
      };
    case "TIME_RECORDS_SUCCESS":
      return {
        ...state,
        status: "success",
        ...action,
      };
    case "TIME_RECORDS_FAILURE":
      return {
        ...state,
        status: "failure",
      };
    default:
      return state;
  }
};
